import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Paragraph, ParagraphProps } from './Paragraph';

export interface StandaloneParagraphProps extends StandaloneComponentProps {
  content?: string;
  attributes?: Record<string, string>;
  options?: ParagraphProps;
}

export const StandaloneParagraph: StandaloneComponent<StandaloneParagraphProps> = ({
  content,
  attributes,
  options,
  ...props
}) => {
  return <Paragraph content={content} attributes={attributes} {...options} {...props} />;
};

export default StandaloneParagraph;
